import { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface VisualizarLaudoBody {
  documento: string;
  tpUsuario: string;
  nome: string;
}

export const postVisualizarLaudo = async (
  cdLaudo: string,
  instance: AxiosInstance,
  body?: VisualizarLaudoBody,
  config?: AxiosRequestConfig,
) => {
  const response = await instance.post(
    `/laudo/${cdLaudo}/visualizar`,
    body,
    config,
  );
  return response;
};

export const getLaudoAcessos = async (
  cdLaudo: string,
  instance: AxiosInstance,
  config?: AxiosRequestConfig,
) => {
  const response = await instance.get(`/laudo/${cdLaudo}/acessos`, config);
  return response;
};
